import { CustomerSearchActionTypes } from "./constants";

export const CUSTOMER_SEARCH_REDUCER = (state, action) => {
  const {searchValue, searchByValue, status} = action.payload || {}; 
    switch (action.type) {
      case CustomerSearchActionTypes.SET_SEARCH_VALUE:
        return {
          ...state,
          searchValue,
          status
        };
      case CustomerSearchActionTypes.SET_SEARCH_BY_VALUE:
        return {
          ...state,
          searchByValue,
          status
        };
        case CustomerSearchActionTypes.SET_STATUS: {
          return {
            ...state,
            status
          };
        }
        case CustomerSearchActionTypes.RESET: {
          return {
            searchValue: '',
            searchByValue: 'userId',
            status: CustomerSearchActionTypes.RESET
          };
        }
      default:
        return state;
    }
  }